import { useDropzone } from "react-dropzone";
import { Avatar, Box } from "@mui/material";

interface AvatarDropzoneProps {
  imageUrl: string;
  onDrop: (acceptedFiles: File[]) => void;
}

const AvatarDropzone: React.FC<AvatarDropzoneProps> = ({
  onDrop,
  imageUrl,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    noClick: !!imageUrl,
    noDrag: !!imageUrl,
  });
  return (
    <Box
      {...getRootProps()}
      sx={{
        width: "100%",
        height: 133,
        margin: 2,
        border: "2px dashed #cccccc",
      }}
    >
      <input {...getInputProps()} disabled={!!imageUrl} />
      {
        <Avatar
          alt="Profile Picture"
          src={imageUrl}
          sx={{
            width: "auto",
            height: "100%",
            borderRadius: "4px",
            objectFit: "cover",
          }}
        />
      }
    </Box>
  );
};

export default AvatarDropzone;
